import React from 'react'
import chart4 from "../../../assets/images/elec/chart1.png"

import "./eleccontent.css"
export default function ElecContent() {
  return (
    <div className='emas__eleccontent'>
        <div className='emas__eleccontent-content'>
            <h1>Simulate the Future through our Indepth Analysis</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Suscipit adipiscing bibendum est ultricies integer quis auctor elit. Sit amet facilisis magna etiam tempor orci eu lobortis elementum.</p>
        </div>
        <div className='emas__eleccontent-image'>
          <img src={chart4} alt="chart1"/>
        </div>
    </div>
  )
}
